import React from "react";
import "./Service_pages.scss";
import img from "./services/teeth_whitening1.jpg"; // Replace with your actual image path
  import imgVisit from "./services/1.JPG";
import { FaCheckCircle, FaThumbsUp, FaStar, FaShieldAlt, FaRegLightbulb, FaWineGlassAlt, FaSmoking, FaMagic, FaInfoCircle } from 'react-icons/fa';
import { MdOutlineHealthAndSafety, MdOutlineVisibility, MdTimer } from "react-icons/md";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const TeethWhitening = () => {

  const stainingCauses = [
    {
      title: "Food & Beverages",
      icon: <FaWineGlassAlt />,
      desc: "Strong pigments in coffee, tea, red wine, berries, and dark sodas attach to the enamel surface over time.",
    },
    {
      title: "Smoking & Tobacco",
      icon: <FaSmoking />,
      desc: "Nicotine and tar create deep brown or yellow stains that are highly resistant to regular brushing alone.",
    },
    {
      title: "Aging & Enamel Wear",
      icon: <MdOutlineVisibility />,
      desc: "As enamel thins with age, the yellowish dentin underneath becomes more visible, dulling the smile.",
    },
    {
      title: "Poor Oral Hygiene",
      icon: <MdOutlineHealthAndSafety />,
      desc: "Irregular brushing and flossing allow plaque and external stains to accumulate and harden on the surface.",
    },
  ];

  const benefits = [
    {
      category: "Visible Results",
      benefit: "Instant Brightening",
      description: "Brighten your teeth by 3–8 shades in just a single 45–60 minute session.",
    },
    {
      category: "Visible Results",
      benefit: "Removes Deep Stains",
      description: "Penetrates deep into the enamel to remove stains that home remedies cannot reach.",
    },
    {
      category: "Safety",
      benefit: "Controlled Procedure",
      description: "Qualified dentists monitor the treatment to ensure complete protection for your gums and enamel.",
    },
    {
      category: "Confidence",
      benefit: "Improved Self-Esteem",
      description: "A brighter, whiter smile significantly enhances overall appearance and social confidence.",
    },
    {
      category: "Longevity",
      benefit: "Long-Lasting Impact",
      description: "Professional whitening can last from 6 months up to 2 years with proper clinical aftercare.",
    },
  ];

  // const reasons = [
  //   {
  //     icon: <FaUserMd />,
  //     title: 'Expert Cosmetic Care',
  //     description: 'Led by Dr. Shankhadeep Saha, an experienced specialist in modern smile transformation procedures.'
  //   },
  //   {
  //     icon: <FaMagic />,
  //     title: 'Advanced Whitening Tech',
  //     description: 'We use professional-grade systems and laser-activated gels for superior, even whitening.'
  //   },
  //   {
  //     icon: <FaShieldAlt />,
  //     title: 'Safety First Approach',
  //     description: 'Strict clinical protocols to protect tooth sensitivity and prevent gum irritation.'
  //   },
  //   {
  //     icon: <FaThumbsUp />,
  //     title: 'Instant Shade Improvement',
  //     description: 'See immediate results in just one visit, perfect for weddings or special events.'
  //   },
  //   {
  //     icon: <FaHeart />,
  //     title: 'Patient-Centric Comfort',
  //     description: 'A relaxing environment where we prioritize your comfort during the treatment process.'
  //   },
  //   {
  //     icon: <FaClinicMedical />,
  //     title: 'Comprehensive Smile Care',
  //     description: 'From whitening to full smile design, all your cosmetic needs are met under one roof in HSR.'
  //   }
  // ];

  return (
    <>
      <div className="service1-section">
        <Helmet>
          <title>Teeth Whitening in HSR Layout | Professional Teeth Bleaching Bengaluru</title>
          <meta
            name="description"
            content="Restore your smile's brightness with professional teeth whitening in HSR Layout at Kosmix Dental Clinic. Safe, effective, and instant results in just one visit."
          />
          <link
            rel="canonical"
            href="https://www.kosmixdentalclinic.com/services/teeth-whitening-in-hsr-layout"
          />
        </Helmet>

        <div className="hero">
          <h1 className="service1-title-text" data-aos="fade-down" data-aos-delay="200" style={{ fontFamily: 'initial' }}>
            Professional Teeth Whitening in HSR Layout, Bengaluru
          </h1>

          <div className="hero-content">
            <div className="hero-image" data-aos="zoom-in-right" data-aos-delay="200" data-aos-duration="800">
              <img src={img} alt="Professional Teeth Whitening" />
            </div>

            <div className="hero-text" data-aos="zoom-in-left" data-aos-delay="200" data-aos-duration="800">
              <p>
                A bright white smile can dramatically improve confidence and overall appearance. Over time, teeth often become stained due to coffee, tea, smoking, aging, and poor oral hygiene. <strong>Professional teeth whitening</strong> offers a safe and effective way to restore your smile's natural brightness.
              </p>
              <p>
                At Kosmix Dental Clinic in HSR Layout, we provide advanced cosmetic dental care designed to remove stubborn stains while protecting your tooth health. Led by <strong>Dr. Shankhadeep Saha</strong>, we ensure that every smile transformation is precise, safe, and long-lasting.
              </p>
              <p>
                Whether you're preparing for a special occasion or simply want to refresh your look, our clinical whitening systems deliver visible results in just one visit, far exceeding the performance of over-the-counter kits.
              </p>
            </div>
          </div>
        </div>

        <div className="content" data-aos="fade-up" data-aos-delay="300" >
          <SectionTitle title="What is Professional Teeth Whitening?" />
          <div className="text_first" >
            <p1>
              Teeth whitening is a cosmetic procedure that lightens the color of teeth by removing deep-seated stains and discoloration. The treatment utilizes professional-grade bleaching agents like hydrogen peroxide to break down stains on the enamel. Unlike home kits, clinical whitening is dentist-supervised, ensuring even results without damaging the enamel or causing severe sensitivity.
            </p1>
          </div>
        </div>

        <section className="staining-glow-mosaic">
          <div className="content">
            <h2 className="section-title" data-aos="fade-up">Why Do Teeth Become Stained?</h2>
            <p className="text_first" data-aos="fade-up" data-aos-delay="100">
              Understanding the source of discoloration is the first step toward a brighter smile:
            </p>
          </div>

          <div className="mosaic-grid">
            {stainingCauses.map((item, index) => (
              <div className="mosaic-item" data-aos="fade-up" data-aos-delay={150 + index * 100} key={index}>
                <div className="icon-box">{item.icon}</div>
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
                <div className="bg-number">0{index + 1}</div>
              </div>
            ))}
          </div>
        </section>

        <section className="timeline-container" style={{ overflowX: 'hidden', padding: '0 1rem' }}>
          <div className="content" data-aos="fade-up">
            <SectionTitle title="The Whitening Procedure: Step-by-Step" />
            <p className="text_first">
              Most professional whitening procedures take between 45 to 60 minutes for instant results:
            </p>
          </div>

          <div className="timeline-step" data-aos="fade-right">
            <div className="timeline-icon">🩺</div>
            <div className="timeline-content">
              <h3>Initial Dental Examination</h3>
              <p>The dentist examines teeth and gums to ensure health and rule out untreated cavities.</p>
            </div>
            <div className="timeline-icon">1</div>
          </div>

          <div className="timeline-step" data-aos="fade-left">
            <div className="timeline-icon">🦷</div>
            <div className="timeline-content">
              <h3>Teeth Cleaning (Scaling)</h3>
              <p>Plaque and tartar are professionally removed to allow the gel to contact the enamel directly.</p>
            </div>
            <div className="timeline-icon">2</div>
          </div>

          <div className="timeline-step" data-aos="fade-right">
            <div className="timeline-icon">🛡️</div>
            <div className="timeline-content">
              <h3>Gum Protection</h3>
              <p>A specialized protective barrier is applied to the gums to prevent irritation from the whitening agent.</p>
            </div>
            <div className="timeline-icon">3</div>
          </div>

          <div className="timeline-step" data-aos="fade-left">
            <div className="timeline-icon">✨</div>
            <div className="timeline-content">
              <h3>Gel Application & Activation</h3>
              <p>The whitening gel is applied and activated using special dental lights or lasers for maximum power.</p>
            </div>
            <div className="timeline-icon">4</div>
          </div>

          <div className="timeline-step" data-aos="fade-right">
            <div className="timeline-icon">📋</div>
            <div className="timeline-content">
              <h3>Final Rinse & Evaluation</h3>
              <p>The gel is removed, and the new shade is evaluated against the initial clinical baseline.</p>
            </div>
            <div className="timeline-icon">5</div>
          </div>
        </section>

        <section className="benefits-section" data-aos="fade-up">
          <div className="benefits-wrapper">
            <div className="content">
              <h2 className="section-title">Benefits of Professional Whitening</h2>
            </div>
            <div className="table-responsive">
              <table className="styled-table">
                <thead>
                  <tr>
                    <th>Category</th>
                    <th>Specific Advantage</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {benefits.map((item, index) => (
                    <tr key={index}>
                      <td className="category-cell">
                        {index === 0 || item.category !== benefits[index - 1].category ? item.category : ""}
                      </td>
                      <td>{item.benefit}</td>
                      <td>{item.description}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>

        <section className="professional-vs-home">
          <div className="content" data-aos="fade-up">
            <h2 className="section-title">Professional Whitening vs. Home Kits</h2>
            <p className="text_first" style={{ marginBottom: '40px' }}>Why clinical whitening is the superior choice for your safety and results:</p>
          </div>

          <div className="comparison-grid-new">
            {[
              { feature: "Effectiveness", pro: "Maximum (Instant Shade Jump)", home: "Moderate & Limited Results", icon1: <FaCheckCircle />, icon2: <FaInfoCircle /> },
              { feature: "Safety", pro: "Clinically Supervised Care", home: "High Risk of Gum Irritation", icon1: <FaShieldAlt />, icon2: <FaRegLightbulb /> },
              { feature: "Time Needed", pro: "Just 60 Minutes (Single Visit)", home: "14–21 Days of Daily Application", icon1: <MdTimer />, icon2: <MdTimer /> },
              { feature: "Overall Result", pro: "100% Perfectly Uniform", home: "Often Patchy or Uneven", icon1: <FaMagic />, icon2: <MdOutlineVisibility /> },
              { feature: "Durability", pro: "Long Lasting (Up to 2 Years)", home: "Fades Quickly (Needs Frequent Touchups)", icon1: <FaStar />, icon2: <FaThumbsUp /> }
            ].map((item, index) => (
              <div className="comparison-row-new" key={index} data-aos="fade-up" data-aos-delay={index * 50}>
                <div className="side pro-side">
                  <div className="side-content">
                    <span className="icon-wrapper pro">{item.icon1}</span>
                    <span className="text-val">{item.pro}</span>
                  </div>
                </div>

                <div className="feature-middle">
                  <div className="feature-pill">{item.feature}</div>
                </div>

                <div className="side home-side">
                  <div className="side-content">
                    <span className="text-val">{item.home}</span>
                    <span className="icon-wrapper home">{item.icon2}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="pricing-section" data-aos="fade-up">
          <div className="pricing-content">
            <div className="text-area">
              <div className="content" data-aos="fade-up">
                <SectionTitle title="Aftercare & Result Longevity" />
                <p>
                  Professional whitening results typically last <strong>6 months to 2 years</strong>. To maintain your bright smile, avoid smoking, limit staining beverages (coffee/tea), and use a soft toothbrush.
                </p>
                <p>
                  We recommend using a straw for colored drinks for the first 48 hours and avoiding highly colored foods immediately after treatment to prevent new stains from setting.
                </p>
              </div>
            </div>

            <div className="price-cards">
              <div className="price-card">
                <div className="tag">Good Candidate</div>
                <h3 className="price">Healthy Smile</h3>
                <p className="desc">Ideal for individuals who:</p>
                <ul className="details">
                  <li>● Have yellow/stained teeth</li>
                  <li>● Maintain good hygiene</li>
                  <li>● Have no untreated cavities</li>
                  <li>● Want cosmetic improvement</li>
                </ul>
              </div>

              <div className="price-card premium">
                <div className="tag premium-tag">Quick Results</div>
                <h3 className="price">3–8 Shades</h3>
                <p className="desc">Immediate visible transformation</p>
                <ul className="details">
                  <li>● 45-60 Minute Treatment</li>
                  <li>● Safe Gutta-Percha Protection</li>
                  <li>● Laser Activation Option</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="faq-section-premium" data-aos="fade-up" style={{ padding: '80px 20px' }}>
          <div className="content" style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <SectionTitle title="Teeth Whitening Frequently Asked Questions" />
            <div className="faq-grid" style={{ 
              display: 'grid', 
              gridTemplateColumns: '1fr', 
              gap: '20px', 
              marginTop: '40px',
              maxWidth: '900px',
              margin: '40px auto 0'
            }}>
              {[
                { q: "Is teeth whitening safe for my enamel?", a: "Yes. Clinical whitening uses professional-grade gels that are safe for enamel. The process is carefully monitored by Dr. Saha to ensure no damage occurs to your tooth structure." },
                { q: "Will I experience tooth sensitivity?", a: "Some patients feel mild temporary sensitivity for 24-48 hours. We use specialized desensitizing agents and protective barriers to minimize any discomfort." },
                { q: "How many shades lighter will my teeth get?", a: "Most patients see a significant improvement of 3 to 8 shades in just one session. The exact result depends on your initial shade and lifestyle." },
                { q: "How long do the whitening results last?", a: "Results typically last 6 months to 2 years. Avoiding smoking and limiting staining beverages like coffee or tea will help maintain your results longer." },
                { q: "Can I whiten my crowns or veneers?", a: "No. Whitening agents only work on natural teeth. If you have dental work, we can discuss options to match their shade to your new, brighter natural smile." },
                { q: "Is the clinical procedure painful?", a: "Not at all. The procedure is generally painless and comfortable. Most patients relax or even listen to music during the 1-hour professional session." }
              ].map((faq, i) => (
                <div key={i} style={{ 
                  background: i % 2 === 0 ? '#fdf6ec' : '#ffffff', 
                  padding: '25px', 
                  borderRadius: '12px', 
                  borderLeft: i % 2 === 1 ? 'none' : '6px solid #561b0f',
                  borderRight: i % 2 === 1 ? '6px solid #561b0f' : 'none',
                  boxShadow: '0 6px 15px rgba(86, 27, 15, 0.05)',
                  textAlign: 'left'
                }}>
                  <p style={{ margin: 0, color: '#3d2a1e', fontSize: '16px', lineHeight: '1.6' }}>
                    <strong style={{ color: '#561b0f', fontSize: '18px', display: 'block', marginBottom: '8px' }}>{faq.q}</strong>
                    {faq.a}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <div className="summary-section" style={{ padding: '30px 0 60px', clear: 'both' }} data-aos="fade-up">
          <SectionTitle title="Visit Kosmix for the Best Teeth Whitening in Bengaluru" />
          
          <div className="cleaning-hero-content" style={{ marginTop: '40px' }}>
            <div className="cleaning-hero-text" data-aos="zoom-in-left">
              <p>
                Don’t let stains hold back your confidence. Choose <strong>Kosmix Dental Clinic</strong>, a premier destination for cosmetic dentistry in HSR Layout.
              </p>
              <p>
                Under the expert care of Dr. Shankhadeep Saha, we provide gentle, safe, and thorough laser teeth whitening designed to give you a bright, healthy smile you can be proud of.
              </p>
            </div>

            <div className="cleaning-hero-image" data-aos="zoom-in-right">
              <img src={imgVisit} alt="Kosmix Dental Clinic Facility" />
            </div>
          </div>
        </div>

        <section className="cta-section" data-aos='zoom-in'>
          <div className="cta-content">
            <h2>Schedule Your Whitening <span>Today!</span></h2>
            <p>Ready for a brighter smile? Book your session at Kosmix Dental Clinic and see visible results in just one hour.</p>
            <div className="cta-buttons">
              <Link to="/#appointment">
                <button className="btn-primary">Book Whitening Session</button>
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

const SectionTitle = ({ title }) => (
  <h2 className="section-title">{title}</h2>
);

export default TeethWhitening;